import React, { useEffect, useState } from 'react'
import { Grid, Header, Row } from '@plurall/elo-beta'
import { PERSONAL_DATA } from 'graphql/queries'
import { useNavigate } from 'react-router-dom'
import MainMenu from '../../components/MainMenu/MainMenu'
import CardResponsiblesList from './CardResponsiblesList'
import { graphqlClient, handleGraphQLErrorsWithToast, redirectToHome } from 'utils'
import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'
import { ROUTES } from 'utils/constants'

const LinkedResponsible = () => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    getPersonalData()
  }, [])

  useEffect(() => {
    getPersonalData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getPersonalData = async () => {
    try {
      const { data } = await graphqlClient().query({
        query: PERSONAL_DATA,
      })

      setData(data)
    } catch (e) {
      handleGraphQLErrorsWithToast(
        e,
        'Não foi possível carregar os dados. Tente novamente mais tarde.',
      )

      setError(e)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingContainer text='Carregando informações..' fullscreen />
  }

  if (error) {
    redirectToHome()
    return null
  }

  const navigateToAccountApproval = () => navigate(ROUTES.PERFIL_APROVACAO_CONTA)

  return (
    <>
      <Header description='Gerencie os responsáveis que estão vinculados a sua conta.'>
        Responsáveis vinculados
      </Header>
      <Grid desktop={12}>
        <Row>
          <MainMenu />
          <Grid desktop={9}>
            <CardResponsiblesList
              data={data}
              navigateToAccountApproval={navigateToAccountApproval}
            />
          </Grid>
        </Row>
      </Grid>
    </>
  )
}

export default LinkedResponsible
